import React, { useState } from "react";
import { useMutation } from "react-query";
import { useNavigate, useLocation } from "react-router-dom";
import {
	searchNewApplicant,
	generateNewApplicantMoMoPayment,
} from "../../../../api/apiServices";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import UserRoles from "../../../../hooks/userRoles";
import useAuth from "../../../../hooks/useAuth";
import jwt_decode from "jwt-decode";
import toast, { Toaster } from "react-hot-toast";

const NewApplicantMomoPayments = () => {
	const { auth } = useAuth();
	const decoded = auth?.accessToken
		? jwt_decode(auth.accessToken)
		: undefined;

	const role = decoded?.UserInfo?.role || "";

	let curr = new Date();
	curr.setDate(curr.getDate());
	let date = curr.toISOString().substring(0, 10);

	const navigate = useNavigate();
	const location = useLocation();
	const from = location.state?.from?.pathname || "/";

	const [search, setSearch] = useState(false);
	const [member, setMember] = useState({});
	const [email, setEmail] = useState("");
	const [mobile_number, setMobileNumber] = useState("");
	const [searchMessage, setSearchMessage] = useState("");

	const [memberSelected, setMemberSelected] = useState("");
	const [isSelected, setIsSelected] = useState(false);

	const [payment_year, setPaymentYear] = useState("");
	const [payment_amount, setPaymentAmount] = useState("");
	const [transaction_id, setTransactionId] = useState("121212121212");
	const [payment_date, setPaymentDate] = useState(date);

	const payment_type = "MP";
	const payment_mode = "M";
	const pay_channel = "NEW-APPLICANT";

	const year = 2018;
	const years = Array.from(new Array(20), (val, index) => index + year);

	const handleSearch = async (e) => {
		e.preventDefault();

		const searchData = {
			email: email.trim(),
			mobile_number: mobile_number.trim(),
		};
		searchMutation.mutate(searchData);
	};

	const searchMutation = useMutation(searchNewApplicant, {
		onSuccess: async (res) => {
			if (res.success) {
				setMember(res.member);
				setSearch(true);
			} else {
				if (res.member) {
					setEmail("");
					setMobileNumber("233");
					setMember(res.member);
					setSearch(true);
					setSearchMessage(res.message);
				} else {
					setEmail("");
					setMobileNumber("233");
					setMember({});
					setSearch(false);
					setSearchMessage(res.message);
				}
			}
		},
	});

	const handleGenerateNumber = async (e) => {
		e.preventDefault();

		const paymentData = {
			member_id: memberSelected?.id,
			pf_number: "",
			fullname:
				memberSelected?.first_name +
				" " +
				memberSelected?.middle_name +
				" " +
				memberSelected?.last_name,
			mobile_number: memberSelected?.mobile_number,
			payment_mode: payment_mode,
			transaction_id: transaction_id,
			payment_year: payment_year,
			payment_amount: payment_amount,
			payment_date: payment_date,
			payment_type: payment_type,
			pay_channel: pay_channel,
		};
		generateMutation.mutate(paymentData);
	};

	const generateMutation = useMutation(generateNewApplicantMoMoPayment, {
		onSuccess: async (res) => {
			if (res.success) {
				setEmail("");
				setMobileNumber("233");
				setSearch(false);
				setIsSelected(false);
				toast.success(res.message, {
					duration: 5000,
					className: "toast-message",
				});
			} else {
				toast.error(res.message, {
					duration: 5000,
					className: "toast-message",
				});
				setEmail("");
				setMobileNumber("233");
				setSearch(false);
				setIsSelected(false);
			}
		},
	});

	const handleCancel = () => {
		setEmail("");
		setMobileNumber("233");
		setSearch(false);
		setIsSelected(false);
		// navigate(from, { replace: true });
	};
	const handleMemberSelected = (id) => {
		if (role === UserRoles.SuperAdmin || role === UserRoles.SystemAdmin) {
			setIsSelected(true);
			// let memberFound = member?.filter((item) => item.id === id);
			setMemberSelected(member);
			// navigate(`/amend_region/${id}`);
		} else {
			toast.error(
				"You are not authorized to perform this function. Contact the System Administrator",
				{
					duration: 3000,
					className: "toast-message",
				}
			);
			setIsSelected(false);
			return false;
		}
	};

	const searchContent = (
		<form onSubmit={handleSearch}>
			<div className="form-group row">
				<div className="col-sm-4">
					<input
						className="form-control"
						type="text"
						placeholder="Email"
						onChange={(e) => setEmail(e.target.value)}
						value={email}
					/>
				</div>
				<div className="col-sm-4">
					<PhoneInput
						id="mobile_number"
						inputStyle={{
							paddingTop: 16,
							paddingRight: 14,
							paddingBottom: 15,
							paddingLeft: 58,
							fontSize: 16,
							width: "100%",
							zIndex: 1,
							height: 40,
							backgroundColor: "#F3F6F9",
						}}
						country={"gh"}
						countryCodeEditable={false}
						enableSearch={true}
						value={mobile_number}
						name="mobile_number"
						// onBlur={(e) => handleFindMember(e)}
						onChange={(mobile_number) =>
							setMobileNumber(mobile_number)
						}
					/>
				</div>

				<div className="col-sm-4">
					<button
						type="submit"
						className="btn btn-success btn-block "
					>
						{" "}
						<i className="fa fa-search"></i> Search
					</button>
				</div>
			</div>
		</form>
	);

	const paymentDetails = (
		<>
			<fieldset className="col-sm-12">
				<legend>Payment Details</legend>
			</fieldset>
			<form onSubmit={handleGenerateNumber}>
				<div className="form-group row">
					<fieldset className="col-sm-6">
						<label
							htmlFor="payment_year"
							className="col-sm-3 col-form-label"
						>
							Select Year<span>&nbsp;&nbsp;*</span>
						</label>
						<div className="col-sm-9">
							<select
								type="text"
								id="payment_year"
								autoComplete="off"
								inputStyle={{ height: "40px" }}
								onChange={(e) => setPaymentYear(e.target.value)}
								value={payment_year}
								required
								name="payment_year"
								className="form-control"
							>
								<option value=""></option>
								{years.map((year, index) => (
									<option value={year} key={`year${index}`}>
										{year}
									</option>
								))}
							</select>
						</div>
						<label
							htmlFor="payment_amount"
							className="col-sm-3 col-form-label"
						>
							Amount Paid<span>&nbsp;&nbsp;*</span>
						</label>
						<div className="col-sm-9">
							<input
								type="number"
								id="payment_amount"
								autoComplete="off"
								onChange={(e) =>
									setPaymentAmount(e.target.value)
								}
								value={payment_amount}
								required
								name="payment_amount"
								className="form-control"
							/>
						</div>
						<label
							htmlFor="transaction_id"
							className="col-sm-3 col-form-label"
						>
							Transaction ID<span>&nbsp;&nbsp;*</span>
						</label>
						<div className="col-sm-9">
							<input
								type="text"
								id="transaction_id"
								autoComplete="off"
								style={{
									textTransform: "uppercase",
								}}
								onChange={(e) =>
									setTransactionId(e.target.value)
								}
								value={transaction_id}
								required
								name="transaction_id"
								className="form-control"
							/>
						</div>
						<label
							htmlFor="payment_date"
							className="col-sm-3 col-form-label"
						>
							Payment Date<span>&nbsp;&nbsp;*</span>
						</label>
						<div className="col-sm-9">
							<input
								type="date"
								id="payment_date"
								autoComplete="off"
								onChange={(e) => setPaymentDate(e.target.value)}
								required
								value={payment_date}
								name="payment_date"
								className="form-control"
							/>
						</div>
					</fieldset>
				</div>
				<div className="panel-footer">
					<div className="row">
						<div className="col-sm-2">
							<button
								type="submit"
								className="btn btn-success btn-block "
							>
								<i className="fa fa-edit"></i> Generate
							</button>
						</div>
						&nbsp;&nbsp;&nbsp;&nbsp;
						<div className="col-sm-2">
							<button
								type="button"
								className="btn btn-danger btn-block "
								onClick={handleCancel}
							>
								<i className="fa fa-search"></i> Cancel
							</button>
						</div>
					</div>
				</div>
			</form>
		</>
	);

	let content;
	if (search) {
		content =
			member && member?.length <= 0 ? (
				<div className="table-responsive lg">
					<table className="table table-bordered">
						<tbody>
							<tr>
								<td
									style={{
										fontSize: "20px",
										fontWeight: "700",
										color: "#000",
										textAlign: "center",
									}}
								>
									<p style={{ color: "brown" }}>
										{searchMessage}
									</p>
								</td>
							</tr>
						</tbody>
					</table>

					<div className="panel-footer">
						<div className="search-group">
							<button
								type="submit"
								className="btn btn-danger "
								onClick={handleCancel}
							>
								<i className="fa fa-search"></i> Cancel
							</button>
						</div>
					</div>
				</div>
			) : member && member?.pf_number ? (
				<div className="table-responsive lg">
					<table className="table table-bordered">
						<tbody>
							<tr>
								<td
									style={{
										fontSize: "20px",
										fontWeight: "700",
										color: "#000",
										textAlign: "center",
									}}
								>
									<p style={{ color: "brown" }}>
										{searchMessage}
									</p>
								</td>
							</tr>
						</tbody>
					</table>
					<div className="panel-footer">
						<div className="search-group">
							<button
								type="submit"
								className="btn btn-danger "
								onClick={handleCancel}
							>
								{" "}
								<i className="fa fa-search"></i> Cancel
							</button>
						</div>
					</div>
				</div>
			) : member && !member?.pf_number ? (
				<>
					<div className="table-responsive lg">
						<table className="table table-borderless table-hover table-striped">
							<thead className="align">
								<tr>
									<th scope="col">#</th>
									<th scope="col">PF Number</th>
									<th scope="col">Full Name</th>
									<th scope="col">Region</th>
									<th scope="col">Mobile Number</th>
									<th scope="col">Email</th>
									<th scope="col">Action</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>{member?.id}</td>
									<td>{member?.pf_number}</td>
									<td style={{ whiteSpace: "nowrap" }}>
										{member?.first_name +
											" " +
											member?.middle_name +
											" " +
											member?.last_name}
									</td>
									<td style={{ whiteSpace: "nowrap" }}>
										{member?.region}
									</td>
									<td style={{ whiteSpace: "nowrap" }}>
										{member.mobile_number}
									</td>
									<td>{member.email}</td>
									<td style={{ whiteSpace: "nowrap" }}>
										<div
											style={{
												display: "inline-block",
												whiteSpace: "nowrap",
											}}
										>
											<button
												onClick={() =>
													handleMemberSelected(
														member.id
													)
												}
												className="btn btn-danger"
											>
												<i className="fa fa-edit"></i>{" "}
												Select Member
											</button>
										</div>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</>
			) : null;
	}

	return (
		<>
			<section className="content-header">
				<Toaster toastOptions={{ position: "top-center" }} />
				<h1>Capture MoMo Payment - For New Applicant</h1>
			</section>
			<section className="content">
				<div className="box">
					<div className="box-body">
						<div className="panel panel-default panel-br-4">
							<div className="panel-heading">
								<div className="row">
									<div className="col-sm-12">
										<h4 className="panel-title">
											{searchContent}
										</h4>
									</div>
								</div>
							</div>
							<div className="panel-body">{content}</div>
							<div className="panel-body">
								{isSelected ? paymentDetails : null}
							</div>
						</div>
					</div>
				</div>
			</section>
		</>
	);
};

export default NewApplicantMomoPayments;
